import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useInvMyAccounts = () => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["inv-my-accounts"],
    queryFn: async () => {
      const urlKey = t("inv-my-accounts");
      const response = await axios.get(urlKey);
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
